<template>
  <FloatFrameAddBtnWrapper
    v-show="false
    "
    :class="{ [addBtnActive.direction]: true }"
    :style="`height: ${heightElement}px; z-index: 7; pointer-events: none;`"
    id="floatFrameAddBtn"
    :position="addBtnActive.position"
  >
    <FloatFrameAddBtnContainer  class="widget-margin-container" style=""
      @mouseover.stop.prevent
    >
      <FloatFrameAddBtnContent
        class="center-hv d-flex justify-content-center"
        v-if="detectDevice == 'desktop'"
      >
        <ToolIconWrapper class="d-flex justify-content-center" :style="`gap: 0px; min-width: inherit;`">
          <ToolIcon
            class="mx-15 cursor-pointer add-btn"
            :style="{'padding': '0px 6px'}"
            style="cursor: pointer; pointer-events: all;"
            v-b-tooltip.hover
            :title="addBtnActive.label_add_btn"
            @click.stop.prevent="addAction"
          >
            <span>
              <i class="fas fa-plus"></i>
            </span>
          </ToolIcon>
        </ToolIconWrapper>
      </FloatFrameAddBtnContent>
    </FloatFrameAddBtnContainer>
  </FloatFrameAddBtnWrapper>
</template>

<script>
import { mapGetters } from "vuex";

import {
  FloatFrameAddBtnWrapper,
  FloatFrameAddBtnContainer,
  FloatFrameAddBtnContent,
  ToolIcon,
  ToolIconWrapper,
} from "./FloatFrameAddBtn.styled";
export default {
  components: {
    FloatFrameAddBtnWrapper,
    FloatFrameAddBtnContainer,
    FloatFrameAddBtnContent,
    ToolIcon,
    ToolIconWrapper,
  },
  data() {
    return {
      resize: false,
      allHeightContent: 0,
    };
  },
  props: {
    
  },
  computed: {
    ...mapGetters({
      detectDevice: "detectDevice",
      preview: "designIframe/preview",
      components: "designIframe/metadata/components",
      mode: "designIframe/mode",
      renderTools: "designIframe/frame/renderTools",
      addBtnActive: "designIframe/frame/addBtnActive",
      languageEngine: "designIframe/userPreference/languageEngine",
      cellActive: "designIframe/frame/cellActive",
      slideContainerActive: "designIframe/frame/slideContainerActive",
    }),
    element() {
      return this.addBtnActive.id && this.components[this.addBtnActive.id];
    },
    attr() {
      switch (this.addBtnActive.direction) {
        case "top":
          return "marginTop";
        default:
          return "marginBottom";
      }
    },
    heightElement() {
      // if (this.cellActive.id && this.addBtnActive.id && this.cellActive.id == this.addBtnActive.parent_id) {
      //   const cellComponentsID = this.components[this.cellActive.id].componentsID;
      //   if (!this.addBtnActive.direction && !this.addBtnActive.id && cellComponentsID <= 0) return 0;
      //   const element = document.getElementById(`resize-margin-${this.addBtnActive.direction}-${this.addBtnActive.id}`);
      //   const rect = element.getBoundingClientRect();
      //   const height = parseInt(rect.height);
      //   return height;
      // }
      // if (this.slideContainerActive.id && this.addBtnActive.id && this.slideContainerActive.id == this.addBtnActive.parent_id) {
      //   const slideContainerComponentsID = this.components[this.slideContainerActive.id].componentsID;
      //   if (!this.addBtnActive.direction && !this.addBtnActive.id && slideContainerComponentsID <= 0) return 0;
      //   const element = document.getElementById(`resize-margin-${this.addBtnActive.direction}-${this.addBtnActive.id}`);
      //   const rect = element.getBoundingClientRect();
      //   const height = parseInt(rect.height);
      //   return height;
      // }
      return 0
    },
    parentElement() {
      return this.addBtnActive.parent_id && this.components[this.addBtnActive.parent_id]
    },
    checkAllWidgetAlignX() {
      let alignX = this.parentElement.style.alignX
      if (this.parentElement.componentsID.length > 0) {
        let arrayWidgetAlignX = [];
        this.parentElement.componentsID.map(id => {
          let widgetHorizontal = undefined;
          if (this.components[id].type == "SECTION_WIDGET_TEXT") {
            widgetHorizontal = this.components[id].style.positionX
          } else if (
            this.components[id].type == "SECTION_WIDGET_COUNTER"
            || this.components[id].type == "SECTION_WIDGET_FORM"
            || this.components[id].type == "SECTION_WIDGET_CONTACT"
            || this.components[id].type == "SECTION_WIDGET_FAQ"
            || this.components[id].type == "SECTION_WIDGET_QUOTATION_FORM"
          ) {
            widgetHorizontal = null
          } else if ('alignX' in this.components[id].style) {
            widgetHorizontal = this.components[id].style.alignX
          } else if ('positionX' in this.components[id].style) {
            widgetHorizontal = this.components[id].style.positionX
          }
          if (widgetHorizontal != null) {
            arrayWidgetAlignX.push(widgetHorizontal);
          }
        })
        alignX = arrayWidgetAlignX.length > 0 ? arrayWidgetAlignX.reduce((prevAlignX, currentAlignX) => {
          if (prevAlignX && currentAlignX) {
            if(prevAlignX == currentAlignX) {
              return prevAlignX
            } else {
              return 'center'
            }
          } else {
            return 'center'
          }
        }) : this.parentElement.style.alignX
      }
      return alignX
    },
  },
  methods: {
    addAction() {
      const element = document.getElementById(`comp-${this.addBtnActive.id}`);
      const rect = element.getBoundingClientRect();
      const cellWidth = parseInt(rect.width);
      this.$store.commit("designIframe/setStatePath", {
        value: {
          widgetID: this.addBtnActive.id,
          cellID: this.addBtnActive.parent_id,
          direction: this.addBtnActive.direction,
          attribute: this.componentsKey,
          cellWidth,
          cellAlign: this.checkAllWidgetAlignX,
        },
        path: `/component/addComponent/${this.addBtnActive.type}`,
      });

      this.$store.dispatch("design/setMode", {
        mode: `add_${this.addBtnActive.type}`,
      });
    },
    resetComponentHoverPosition() {
      this.$store.dispatch("designIframe/component/setAddBtnAction", {
        component_id: this.addBtnActive.id,
        direction: this.addBtnActive.direction
      });
    },
  },
  watch: {
    mode() {
      this.$nextTick(function () {
        this.resetComponentHoverPosition();
      });
    },
  },
};
</script>

<style lang="scss">
  .icon-hover-label {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    outline: none;
    transition: ease-out 0.3s;
    .icon-label {
      // position: absolute;
      // top: 0px;
      // left: 35%;
      white-space: nowrap;
      pointer-events: none;
      // width: 40px;
      opacity: 0;
      transition: ease-out 0.3s;
    }
    &:hover {
      border-radius: 20px;
      width: 100%;
      .icon-wrapper {
        left: 20%;
      }
      .icon-label {
        opacity: 1;
        position: static;
      }
    }
  }
</style>